export * from './add-object-menu/add-object-menu.component';
export * from './command-list/command-list.component';
export * from './indicator-device/indicator-device.component';
export * from './main-state-info/main-state-info.component';
export * from './state-info/state-info.component';
export * from './timer-add/timer-add.component';
export * from './timers-list/timers-list.component';
export * from './tariffs-block/tariffs-block.component';
export * from './video-background/video-background.component';
export * from './username-field/username-field.component';
export * from './report-stats-item/report-stats-item.component';
export * from './graph-stats/graph-stats.component';
export * from './report-quality/report-quality.component';
export * from './pointer-graph/pointer-graph.component';
export * from './report-quality-graph/report-quality-graph.component';
export * from './bitmask-field/bitmask-field.component';


// WEBPACK FOOTER //
// ./src/app/view/components/index.ts